module.exports = __webpack_public_path__ + "banner.bf4ba33809e71562084fb0018428e5a3.png";